(function () {
  function getRoutes() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return {
      cart: (window.theme && window.theme.routes && window.theme.routes.cart) || root + 'cart',
      checkout: (window.theme && window.theme.routes && window.theme.routes.checkout) || root + 'checkout',
      cartJs: root + 'cart.js',
      cartAdd: (window.theme && window.theme.routes && window.theme.routes.cartAdd) || root + 'cart/add.js'
    };
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-rng-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count < 1);
    });
  }

  function refreshCartCount() {
    var routes = getRoutes();

    return fetch(routes.cartJs, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function showCartNotice(message) {
    var notice = document.querySelector('[data-rng-cart-notice]');
    if (!notice) return;

    notice.textContent = message;
    notice.classList.remove('hidden', 'opacity-0');
    notice.classList.add('opacity-100');

    window.clearTimeout(showCartNotice.timer);
    showCartNotice.timer = window.setTimeout(function () {
      notice.classList.add('opacity-0');
      window.setTimeout(function () {
        notice.classList.add('hidden');
      }, 300);
    }, 2800);
  }

  function addToCart(form, options) {
    options = options || {};
    var routes = getRoutes();
    var formData = new FormData(form);
    var variantId = form.dataset.rngVariantId || formData.get('id');

    if (!variantId) {
      var variantInput = form.querySelector('[data-rng-product-variant-select], input[name="id"]');
      if (variantInput && variantInput.value) {
        variantId = variantInput.value;
      }
    }

    if (!variantId) {
      showCartNotice('Could not add to cart');
      return Promise.resolve(null);
    }

    var quantity = formData.get('quantity') || '1';

    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number(quantity) }]
      })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw payload;
          }
          return payload;
        });
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        var message = (window.theme && window.theme.cartStrings && window.theme.cartStrings.added) || 'Added to cart';
        showCartNotice(message);

        if (options.redirectToCheckout) {
          window.location.href = routes.checkout;
          return;
        }

        window.setTimeout(function () {
          window.location.href = routes.cart;
        }, 700);
      })
      .catch(function (error) {
        var description = error && (error.description || error.message);
        var message = description || (window.theme && window.theme.cartStrings && window.theme.cartStrings.error) || 'Could not add to cart';
        showCartNotice(message);
      });
  }

  function resolveSubmitIntent(form, submitter) {
    if (submitter) {
      if (submitter.hasAttribute('data-rng-product-buy-now') || submitter.closest('[data-rng-product-buy-now]')) {
        return 'buy_now';
      }
      if (submitter.hasAttribute('data-rng-product-add-to-cart') || submitter.closest('[data-rng-product-add-to-cart]')) {
        return 'add_to_cart';
      }
    }

    if (form.querySelector('[data-rng-product-buy-now]')) {
      return 'buy_now';
    }

    if (form.querySelector('[data-rng-product-add-to-cart]')) {
      return 'add_to_cart';
    }

    return null;
  }

  function bindProductForms(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-rng-product-form]').forEach(function (form) {
      if (form.dataset.rngCartBound === 'true') return;

      form.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-rng-product-buy-now], [data-rng-product-add-to-cart]');
        if (!trigger || !form.contains(trigger)) return;

        form.dataset.rngSubmitIntent = trigger.hasAttribute('data-rng-product-buy-now')
          ? 'buy_now'
          : 'add_to_cart';
      });

      form.addEventListener('submit', function (event) {
        var intent = form.dataset.rngSubmitIntent || resolveSubmitIntent(form, event.submitter);
        delete form.dataset.rngSubmitIntent;

        if (!intent) return;

        event.preventDefault();

        if (intent === 'buy_now') {
          addToCart(form, { redirectToCheckout: true });
          return;
        }

        addToCart(form);
      });

      form.dataset.rngCartBound = 'true';
    });
  }

  function init() {
    refreshCartCount();
    bindProductForms();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.RngShop = {
    refreshCartCount: refreshCartCount,
    addToCart: addToCart,
    bindProductForms: bindProductForms
  };
})();
